import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Camera, Settings, Bell, Inbox } from 'lucide-react';

function BottomNav({ newPhotosCount = 0, pendingVerificationsCount = 0 }) {
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const Badge = ({ count, variant = 'primary', testId }) => {
    if (!count || count <= 0) return null;
    return (
      <div
        style={{
          position: 'absolute',
          top: '0.125rem',
          right: '0.25rem',
          background: variant === 'destructive' ? 'hsl(var(--destructive))' : 'hsl(var(--primary))',
          color: 'white',
          borderRadius: '9999px',
          minWidth: '18px',
          height: '18px',
          padding: '0 0.3rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '0.6rem',
          fontWeight: 600,
          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
          animation: 'pulse 2s infinite',
        }}
        data-testid={testId}
      >
        {count > 99 ? '99+' : count}
      </div>
    );
  };

  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      <Link
        to="/feed"
        className={`nav-item ${isActive('/feed') ? 'active' : ''}`}
        data-testid="nav-feed"
        style={{ position: 'relative' }}
      >
        <Home size={22} />
        <span>Feed</span>
        <Badge count={newPhotosCount} testId="new-photos-badge" />
      </Link>

      <Link
        to="/verifications"
        className={`nav-item ${isActive('/verifications') ? 'active' : ''}`}
        data-testid="nav-verifications"
        style={{ position: 'relative' }}
      >
        <Bell size={22} />
        <span>Verify</span>
        <Badge count={pendingVerificationsCount} variant="destructive" testId="pending-verifications-badge" />
      </Link>

      <Link
        to="/camera"
        className={`nav-item ${isActive('/camera') ? 'active' : ''}`}
        data-testid="nav-camera"
        style={{
          transform: 'scale(1.2)',
          color: 'hsl(var(--primary))'
        }}
      >
        <div style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          background: 'hsl(var(--primary))',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          boxShadow: '0 4px 12px hsl(var(--primary) / 0.3)'
        }}>
          <Camera size={28} />
        </div>
      </Link>

      <Link
        to="/inbox"
        className={`nav-item ${isActive('/inbox') ? 'active' : ''}`}
        data-testid="nav-inbox"
        style={{ position: 'relative' }}
      >
        <Inbox size={22} />
        <span>Inbox</span>
      </Link>

      <Link
        to="/settings"
        className={`nav-item ${isActive('/settings') ? 'active' : ''}`}
        data-testid="nav-settings"
      >
        <Settings size={22} />
        <span>Settings</span>
      </Link>
    </nav>
  );
}

export default BottomNav;
